import { createApp } from 'vue';
import store from '@dts/shared/src/store';
import directives from '@dts/shared/src/directives';

import '@dts/shared/src/api';
import '@/router/permission';
import '@/styles/reset.scss';

import router from '@/router';
import App from './App.jsx';
import Loading from '@/components/loading/index';

import 'virtual:svg-icons-register';
import { createPinia } from 'pinia';

window.$dts = window.API.dtsServer;
window.dts = {
  identify: 'ft',
};
const pinia = createPinia();
export const app = createApp(App);
app.use(Loading).use(router).use(store).use(pinia).use(directives).mount('#app');
